import styled from 'styled-components'
import {Card} from 'react-bootstrap'
import CardTitle from '../../../common/styles/CardTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import useLibraryByBookCount from '../useLibraryByBookCount'
import LibraryCardLoading from './LibraryCardLoading'
import LibraryCard from './LibraryCard'
import useLocationStore from "../useLocationStore";
import NoContent from '../../../common/NoContent'

const LibraryByBookCountCard = () => {
	const {lat, long} = useLocationStore()
	const [libraries, isLoading, isError] = useLibraryByBookCount(lat, long, 'ALL', 10)

	return (
		<a href={'/library/ranking'}>
			<Card>
				<CardBodyContentContainer height={600}>
					<CardTitle icon={<booksitoutIcon.popular />} title={'책 많은 도서관 순위'} url={''} />

					{isLoading ? (
						<Row>
							{Array.from({ length: 8 }).map(_ => (
								<Col>
									<LibraryCardLoading />
								</Col>
							))}
						</Row>
					) : libraries.length === 0 ? (
						<NoContentCenter>
							<NoContent message={isError ? '도서관 정보를 불러올 수 없어요' : '아직 도서관 정보가 없어요'} />
						</NoContentCenter>
					) : (
						<Row>
							{libraries.map(library => (
								<Col>
									<LibraryCard library={library} ranking={library.ranking} backgroundColorType={'card-card'} />
								</Col>
							))}
						</Row>
					)}
				</CardBodyContentContainer>
			</Card>
		</a>
	)
}

const Row = styled.div.attrs({
	className: 'row',
})``

const Col = styled.div.attrs({
	className: 'col-12 col-md-6',
})``

const NoContentCenter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 450px;
`

export default LibraryByBookCountCard
